import { baseUrl, apiKey } from '@/config';

export class LeagueService {
  /**
   * Fetch hot leagues
   * @param {Object} params - Query parameters
   * @returns {Promise<Array>}
   */
  static async getHotLeagues(params = {}) {
    try {
      const { page = 1, limit = 10, fields = 'id,name,logo,slug,type' } = params;
      
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        fields,
      });

      const response = await fetch(
        `${baseUrl}/leagues/hot?${queryParams}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-signature': apiKey || '',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data?.data || data || [];
    } catch (error) {
      console.error('Error fetching hot leagues:', error);
      throw error;
    }
  }

  /**
   * Fetch all leagues
   * @param {Object} params - Query parameters
   * @returns {Promise<Array>}
   */
  static async getAllLeagues(params = {}) {
    try {
      const { fields = 'id,name,logo,slug,type' } = params;
      
      const queryParams = new URLSearchParams({
        fields,
      });

      const response = await fetch(
        `${baseUrl}/leagues?${queryParams}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-signature': apiKey || '',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data?.data || data || [];
    } catch (error) {
      console.error('Error fetching all leagues:', error);
      throw error;
    }
  }

  /**
   * Fetch league by ID
   * @param {number} leagueId - League ID
   * @returns {Promise<Object>}
   */
  static async getLeagueById(leagueId) {
    try {
      const response = await fetch(
        `${baseUrl}/leagues/${leagueId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-signature': apiKey || '',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data?.data || data || null;
    } catch (error) {
      console.error(`Error fetching league ${leagueId}:`, error);
      throw error;
    }
  }
}
